import { StatusCode } from '@/modules/asset/constants';
import { computed, Ref } from '@vue/composition-api';

export function useAssetStatus(status: Ref<StatusCode | undefined>) {
    const label = computed(() => {
        switch (status.value) {
            case StatusCode.Available:
            case StatusCode.Internal:
                return 'Available';
            default:
                return status.value;
        }
    });

    const statusClass: Record<string, string> = {
        [StatusCode.Incomplete]: 'text-neutral-100 bg-yellow-600',
        [StatusCode.Uploading]: 'text-neutral-100 bg-purple-800',
        [StatusCode.Updating]: 'text-neutral-100 bg-blue-700',
        [StatusCode.Deleted]: 'text-neutral-100 bg-red-700',
        [StatusCode.Available]: 'text-neutral-100 bg-green-700',
        [StatusCode.Internal]: 'text-neutral-100 bg-green-700',
        [StatusCode.Archived]: 'text-neutral-100 bg-neutral-700', // for model assets
    };

    const colour = computed(() => (status.value ? statusClass[status.value] : 'bg-orange-600'));

    const icon = computed(() => null);

    const iconColour = computed(() => {
        switch (status.value) {
            case StatusCode.Incomplete:
                return 'text-yellow-700';
            case StatusCode.Uploading:
                return 'text-purple-700';
            case StatusCode.Updating:
                return 'text-blue-700';
            case StatusCode.Deleted:
                return 'text-red-700';
            case StatusCode.Available:
            default:
                return 'text-yellow-700';
        }
    });

    return { label, colour, icon, iconColour, statusClass };
}
